import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function chevronUp({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      stroke="black"
      viewBox="0 0 13 11"
      width="13"
      height="11"
      className={className}
    >
      <path
        fill="none"
        d="M6.933.75L11.696 9a.5.5 0 01-.433.75H1.737A.5.5 0 011.304 9L6.067.75a.5.5 0 01.866 0z"
      />
    </svg>
  );
}

export default chevronUp;
